export default __webpack_public_path__ + "static/media/05_photo.8057e764.jpg";